import { render, staticRenderFns } from "./SmsApplicationTour.vue?vue&type=template&id=fcb86d1e&"
import script from "./SmsApplicationTour.vue?vue&type=script&lang=js&"
export * from "./SmsApplicationTour.vue?vue&type=script&lang=js&"
import style0 from "./SmsApplicationTour.vue?vue&type=style&index=0&id=fcb86d1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsApplicationTour%2FSmsApplicationTour.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports